import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Autocomplete, GoogleMap, Marker, useJsApiLoader  } from '@react-google-maps/api';
import { SearchIcon } from '../../icons';
import { LocationSearch } from '../../icons/locationSearch';


const libraries = ['places']

function Map({ bookingSelect, sliderValue, setMapBounds, setSliderValue }) {
  const [center, setCenter] = useState();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  
  const containerStyle = {
    width: windowWidth > 990 && '540px',
    height: '400px',
    borderRadius: '12px',
  };

  
  const mapRef = useRef(null);
  const autoCompleteRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyDXFLTkJcZ-Pyn5uI0KLzUoyPZ8Ay1dRJk",
    libraries: libraries
  })

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener for resize
    window.addEventListener('resize', handleResize);

    // Clean up by removing the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
        setCenter({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        })
      })

  }, [])

  const calculateZoomLevel = useMemo(() => {
    // Calculate the zoom level based on the slider value
  const result = 15 - 1 * (sliderValue);
  return Math.max(1, Math.min(20, Math.round(result)));
  }, [sliderValue])


  const handlePlaceSelect = useCallback((place) => {
    if (mapRef.current && place.geometry && place.geometry.location) {
      setCenter({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
      setMapBounds(mapRef.current.getBounds())
      setSliderValue(2)
    }
  }, []);

  const centerUser = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      setCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      })
      setSliderValue(2);
    })
  }

  const handleBoundsChanged = () => {
    if (mapRef.current) {
      setMapBounds(mapRef.current.getBounds())
    }
  };
  


  return (
    <>
      {isLoaded && <GoogleMap
        mapContainerStyle={containerStyle}
        center={center && center}
        zoom={calculateZoomLevel}
        onBoundsChanged={handleBoundsChanged}
        onLoad={(map) => (mapRef.current = map)}
        onUnmount={()=> mapRef.current === null}
        options={{
          zoomControl: false, // Disable zoom control
          fullscreenControl: false, // Disable fullscreen control
          streetViewControl: false, // Disable street view control
          mapTypeControl: false, // Disable map type control
          scrollwheel: false,
        }}
      >
        <Autocomplete
         onLoad={(autoComplete) => (autoCompleteRef.current = autoComplete)}
         onPlaceChanged={() => handlePlaceSelect(autoCompleteRef.current.getPlace())}
        >
          <div className='flex  max-lg:w-full max-xl:justify-between xl:gap-2 bg-white items-center absolute lg:left-[5vw]'
            style={{
                height: `50px`,
                padding: `0 12px`,
                borderRadius: `3px`,
                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                fontSize: `14px`,
                textOverflow: `ellipses`,
                // position: 'absolute',
                // left: '18%',
                // marginLeft: '-110px',
                borderRadius: '100px',
                marginTop:'20px'
            }}>
            <div className='flex gap-2'>
              <SearchIcon/>
              <input
                type="text"
                placeholder="Αναζήτηση διεύθυνσης"
                style={{
                  width: '300px',
                  border: `1px solid transparent`,
                  boxSizing: `border-box`,
                  outline: `none`,
                }}
                />
              </div>
            <LocationSearch className={'cursor-pointer'} onClick={centerUser}/>
            </div>
        </Autocomplete>
        {bookingSelect!==null  && mapRef.current !== null && 
          Object.keys(bookingSelect.options).map(
            (marker, idx) => {
              return (
                <Marker
                  key={marker}
                  position={
                    bookingSelect.options[marker].coordinates
                  }
                  clickable={false}
                />
              );
            }
          )}
      </GoogleMap>}
      </>
  ) 
}

export default React.memo(Map)